import Vue from 'vue';
import UserInfoTool from './userInfoTool';
import moment from 'moment';

const Utils = {
    /**
     * 对象的深度拷贝
     * @param data 需要拷贝的元数据
     * @return {any} 返回拷贝后的新数据
     */
    deepClone(data) {
        const type = this.getType(data);
        let obj;

        if (type === 'array') {
            obj = [];
        } else if (type === 'object') {
            obj = {};
        } else {
            //不再具有下一层次
            return data;
        }
        if (type === 'array') {
            for (let i = 0, len = data.length; i < len; i++) {
                obj.push(this.deepClone(data[i]));
            }
        } else if (type === 'object') {
            for (let key in data) {
                obj[key] = this.deepClone(data[key]);
            }
        }

        const constructor = data.constructor;
        if (constructor) {
            return Object.assign(new constructor(), obj);
        }
        return obj;
    },

    /**
     * 判断对象类型
     * @param {Object} object
     * @return {String} object type
     */
    getType(object) {
        var toString = Object.prototype.toString;
        var map = {
            '[object Boolean]': 'boolean',
            '[object Number]': 'number',
            '[object String]': 'string',
            '[object Function]': 'function',
            '[object Array]': 'array',
            '[object Date]': 'date',
            '[object RegExp]': 'regExp',
            '[object Undefined]': 'undefined',
            '[object Null]': 'null',
            '[object Object]': 'object'
        };
        if (object instanceof Element) {
            return 'element';
        }
        return map[toString.call(object)];
    },

    /**
     * 在第二级子路由页面使用，当路由切换到其子路由的时候，隐藏当前组件
     * @param {Object} context this
     * @param {String/Array} routeName 可渲染的路由名称
     */
    renderWhen(context, routeName) {
        const router = context.$route;
        if (Array.isArray(routeName)) {
            return routeName.some(name => name === router.name);
        } else {
            return router.name === routeName;
        }
    },
    /**
     *
     * @param {Function} fn target function
     *  ` Must contains two parameters
     */
    promisefy(fn) {
        function awaitable() {
            const args = Array.prototype.slice.call(arguments);
            return new Promise(function (resolve, reject) {
                const callback = function (err, data) {
                    if (err) {
                        reject(err);
                    } else {
                        resolve(data);
                    }
                };
                args.push(callback);
                fn.apply(null, args);
            });
        }

        return awaitable;
    },

    formatTime(timeStamp, timeStr = 'Y-m-d H:i:s') {
        let date = ''
        if (timeStamp instanceof Date) {
            date = timeStamp
        } else {
            date = new Date()
            date.setTime(timeStamp * 1000)
        }
        if (date.toString() === 'Invalid Date') {
            return ''
        }
        let timeObj = {}
        timeObj['Y'] = date.getFullYear()
        let m = date.getMonth() + 1
        timeObj['m'] = m < 10 ? ('0' + m) : m
        let d = date.getDate()
        timeObj['d'] = d < 10 ? ('0' + d) : d
        let H = date.getHours()
        timeObj['H'] = H < 10 ? ('0' + H) : H
        let minute = date.getMinutes()
        let second = date.getSeconds()
        timeObj['i'] = minute < 10 ? ('0' + minute) : minute
        timeObj['s'] = second < 10 ? ('0' + second) : second
        for (var key in timeObj) {
            if (timeObj.hasOwnProperty(key)) {
                timeStr = timeStr.replace(key, timeObj[key])
            }
        }
        return timeStr
    },
    downLoadFile(data, name) {
        if (!data) {
            return
        }
        let url = window.URL.createObjectURL(new Blob([data]))
        let link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.setAttribute('download', name + '.xlsx')
        document.body.appendChild(link)
        link.click()
    },

    // 获取权限所在页面
    findPage(data, name) {
        let arr = []
        data.forEach(element => {
            if (element.name === name) {
                arr.push(element)
            }
            if (element.children) {
                arr = arr.concat(this.findPage(element.children, name))
            }
        });
        return arr
    },
    // 获取权限按钮
    getBtnAuth(name, data) {
        try {
            let auth = JSON.parse(UserInfoTool.getAuth())
            let authArr = this.findPage(auth, name)
            let obj = authArr[authArr.length - 1]
            if (obj) {
                let btns = obj.children
                return data.filter(item => btns.some(btn => btn.name.includes(item.label)))
            } else {
                return data
            }
        } catch (err) {
            console.error(err)
        }
    },
    // 转换为时间戳
    toTimeStamps(value, type) {
        if (!value || !value instanceof Date) {
            return undefined;
        } else {
            if (type == 1) {
                return String(value.unix())
            } else if (type == 2) {
                return String(moment(value.format('lll'), 'YYYY-MM-DD HH:00').unix())
            } else {
                return String(moment(value.format('L'), 'YYYY-MM-DD').unix())
            }
        }
    },
    getQueryString(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        var r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return r[2];
        }
        return null;
    },
    // 倒计时计算
    secondToDate(result) {
        var h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
        var m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
        var s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
        // return result = h + ":" + m + ":" + s;
        if (result <= 0) {
            return result = null;
        } else {
            return result = m + ":" + s;
        }

    },
    // 生成全局唯一id
    generateUUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        })
    },
    toFixed(n, fixed = 2) {
        return ~~(Math.pow(10, fixed) * n) / Math.pow(10, fixed)
    },

    // 判断数组是不是连续
    isContinuityNum(num){
        let array=[];
        if(num instanceof Array){
            array = [...num];
        }else{
            array = Array.from(num.toString())//转换为数组
        }

        var i=array[0];
        var isContinuation=true;
        for(var e in array){
            if(array[e]!=i){
                isContinuation=false;
                break;
            }
            i++;
        }
        return isContinuation;
    },


    // 处理时间，返回xxx天前
    getDateDiff(dateStr){
        // var publishTime = getDateTimeStamp(dateStr) / 1000,
        var publishTime =  Date.parse(dateStr.replace(/-/gi, "/")) / 1000,
            d_seconds,
            d_minutes,
            d_hours,
            d_days,
            timeNow = parseInt(new Date().getTime() / 1000),
            d,

            date = new Date(publishTime * 1000),
            Y = date.getFullYear(),
            M = date.getMonth() + 1,
            D = date.getDate(),
            H = date.getHours(),
            m = date.getMinutes(),
            s = date.getSeconds();
        //小于10的在前面补0
        if (M < 10) {
            M = '0' + M;
        }
        if (D < 10) {
            D = '0' + D;
        }
        if (H < 10) {
            H = '0' + H;
        }
        if (m < 10) {
            m = '0' + m;
        }
        if (s < 10) {
            s = '0' + s;
        }

        d = timeNow - publishTime;
        d_days = parseInt(d / 86400);
        d_hours = parseInt(d / 3600);
        d_minutes = parseInt(d / 60);
        d_seconds = parseInt(d);

        if (d_days > 0 && d_days < 7) {
            return d_days + '天前';
        } else if (d_days <= 0 && d_hours > 0) {
            return d_hours + '小时前';
        } else if (d_hours <= 0 && d_minutes > 0) {
            return d_minutes + '分钟前';
        } else if (d_seconds < 60) {
            if (d_seconds <= 0) {
                return '刚刚';
            } else {
                return d_seconds + '秒前';
            }
        } else if (d_days >= 7 && d_days < 30) {
            return M + '-' + D;
        } else if (d_days >= 30) {
            return Y + '-' + M + '-' + D ;
        }
    },
    getDateTimeStamp(dateStr) {
        // 如果时间格式为2020/07/09 21:43:19.000  需要去掉.000 不然ios和firefox会有问题
        return Date.parse(dateStr.replace(/-/gi, "/"));
    },
    /**
     * 判断操作系统是否存在某字体
     * @param fontName 字体名
     */
    isSupportFont(fontName)  {
        if (typeof fontName !== 'string') return false

        const arial = 'Arial'
        if (fontName.toLowerCase() === arial.toLowerCase()) return true

        const size = 100
        const width = 100
        const height = 100
        const str = 'a'

        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        if (!ctx) return false

        canvas.width = width
        canvas.height = height
        ctx.textAlign = 'center'
        ctx.fillStyle = 'black'
        ctx.textBaseline = 'middle'

        const getDotArray = (_fontFamily) => {
            ctx.clearRect(0, 0, width, height)
            ctx.font = `${size}px ${_fontFamily}, ${arial}`
            ctx.fillText(str, width / 2, height / 2)
            const imageData = ctx.getImageData(0, 0, width, height).data
            return [].slice.call(imageData).filter(item => item !== 0)
        }
        return getDotArray(arial).join('') !== getDotArray(fontName).join('')
    },


    // 生成随机字符串
    randomString(length) {
        var str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        var result = '';
        for (var i = length; i > 0; --i)
            result += str[Math.floor(Math.random() * str.length)];
        return result;
    },

    // RGB颜色 转 16进制
    colorHex(color) {
        // RGB颜色值的正则
        color.trim()
        var reg = /^(rgb|RGB)/;
        // var color = this;
        if (reg.test(color)) {
            var strHex = "#";
            // 把RGB的3个数值变成数组
            var colorArr = color.replace(/(?:\(|\)|rgb|RGB)*/g, "").split(",");
            // 转成16进制
            for (var i = 0; i < colorArr.length; i++) {
                var hex = Number(colorArr[i]).toString(16);
                hex = hex.length == 1 ? '0' + hex : hex;
                if (hex === "0") {
                    hex += hex;
                }
                strHex += hex;
            }
            return strHex;
        } else {
            return String(color);
        }
    },

};

Vue.prototype.$utils = Utils;
export default Utils;
